<template>
	<div class="margin-8-top-bottom flex space-around">

    <section class="option_section">
		<v-select class="width-200 mr-3"  :placeholder="'Pick Option'"  v-validate="'required'" :searchable="true" :reduce="name => name.id" track-by="id" v-model="selection_rules.rule_property_id" single label="name" :options="automation_options" name="main_who_option"></v-select>
    	<span v-if="errors.first('main_who_option')" class="input-error-msg mr-3">This field is required</span>
		</section>
		
		<section  v-if="second_rule_option" class="option_section">
			<v-select class="width-200 mr-3" :placeholder="'Pick Option'" :searchable="true" track-by="value"  v-model="selection_rules.conditional_id" single label="name" :options="second_rule_option" v-validate="'required'" name="option_"></v-select>
			<span v-if="errors.first('option_')" class="input-error-msg mr-3">This field is required</span>
		</section>
	
		<section class="option_section" v-if="second_rule_calendar_view">
		<date-picker  v-if="second_rule_calendar_view" v-model="selection_rules.value" :range="date_picker_range_chosen" :format="'MM-DD-YYYY'" class="width-200" name="date" v-validate="'required'" @clear="dateClear()"
		:placeholder="'Pick a date'" :range-separator="' to '" :lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
		:valueType="'YYYY-MM-DD'"></date-picker>
			<span class="input-error-msg">{{ errors.first('date') }}</span>
		</section>

		<section class="option_section" v-if="!second_rule_calendar_view && second_rule_list_view" >
		<v-select  :class=[auto_width] class="width-200 mr-3" :placeholder="'Pick Option'" @input="clearChildOption()" :searchable="true" track-by="value" v-model="selection_rules.value" single label="name" :options="selection_rules.rule_property_id.data" name="option__" v-validate="'required'"></v-select>
			<span v-if="errors.first('option__')" class="input-error-msg">This field is required</span>
		</section>

		<v-select v-if="sub_location_options" class="width-200" :placeholder="'Pick Option'" :searchable="true" track-by="value" v-model="selection_rules.value_child" single label="name" :options="selection_rules.value.children"></v-select>
	</div>
</template>
<script>
export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    parent_index: {
      type: Number,
      required: false
    },
    update_flag: {
      type: Boolean
    },
    reset_option_available: {
      type: Boolean,
      default: false
    },
    automation_options: {
      type: Array
    },
    who_selection: {
      type: Object,
      required: true,
      default() {
        return {
          rule_property_id: "",
          conditional_id: "",
          value: "",
          value_child: ""
        };
      }
    }
  },
  data: function() {
    return {
      match_all: true,
      selection_rules: {
        rule_property_id: "",
        conditional_id: "",
        value: "",
        value_child: ""
      }
    };
  },
  computed: {
    auto_width() {
      if (this.selection_rules.rule_property_id) {
        if (typeof this.selection_rules.rule_property_id == "object") {
          if (this.selection_rules.rule_property_id.id == 6) {
            return "width_auto";
          } else {
            return "";
          }
        } else {
          if (this.selection_rules.rule_property_id == 6) {
            return "width_auto";
          } else {
            return "";
          }
        }
      } else {
        return "";
      }
    },
    date_picker_range_chosen() {
      if (
        this.selection_rules.conditional_id &&
        this.selection_rules.conditional_id.name
      ) {
        return this.selection_rules.conditional_id.name == "Range";
      } else {
        return false;
      }
    },
    second_rule_option() {
      if (
        ( this.selection_rules.rule_property_id ) &&
        this.selection_rules.rule_property_id != null ||
        this.selection_rules.rule_property_id != ""
      ) {
        return this.selection_rules.rule_property_id.conditionals;
      } else {
        return false;
      }
    },
    second_rule_calendar_view() {
      if (
        ( this.selection_rules.rule_property_id ) &&
        (this.selection_rules.rule_property_id != null ||
          this.selection_rules.rule_property_id != "") &&
        this.selection_rules.rule_property_id.type &&
        this.selection_rules.rule_property_id.type.name &&
        this.selection_rules.rule_property_id.type.name == "date"
      ) {
        return this.selection_rules.rule_property_id.conditionals;
      } else {
        return false;
      }
    },
    second_rule_list_view() {
      if (
        ( this.selection_rules.rule_property_id ) &&
        this.selection_rules.rule_property_id != null ||
        this.selection_rules.rule_property_id != ""
      ) {
        return this.selection_rules.rule_property_id.conditionals;
      } else {
        return false;
      }
    },
    sub_location_options() {
      if (
        !this.second_rule_calendar_view &&
        this.selection_rules.value && 
        (this.selection_rules.value != null ||
          this.selection_rules.value != "") &&
        this.selection_rules.value.children &&
        this.selection_rules.value.children.length > 0
      ) {
        return this.selection_rules.value.children;
      } else {
        return false;
      }
    },
    get_selection_rules_ids() {
      let temp_selection_rules = {
        rule_property_id: "",
        conditional_id: "",
        value: "",
        value_child: ""
      };
      if (
        this.selection_rules &&
        this.selection_rules.rule_property_id &&
        this.selection_rules.rule_property_id.id
      ) {
        temp_selection_rules.rule_property_id = this.selection_rules.rule_property_id.id;
        if (
          this.selection_rules.conditional_id &&
          this.selection_rules.conditional_id.id
        ) {
          temp_selection_rules.conditional_id = this.selection_rules.conditional_id.id;
        }
        if (this.selection_rules.value) {
          if (this.selection_rules.value.id) {
            temp_selection_rules.value = this.selection_rules.value.id;
          } else {
            temp_selection_rules.value = this.selection_rules.value;
          }
        }
        if (
          this.selection_rules.value_child &&
          this.selection_rules.value_child.id
        ) {
          temp_selection_rules.value_child = this.selection_rules.value_child.id;
        }
        return temp_selection_rules;
      } else {
        return null;
      }
    }
  },
  beforeDestroy() {
    this.$nextTick(() => {
			document.querySelector(".main-section").style['overflow-y'] = "hidden";
      this.cleanMemory();
    });
  },
  watch: {
    selection_rules:{
      handler(val){
       if(val != this.selection_rules){
          this.$validator.validateAll().then(result => {
           console.log(result)
        });
       }
       
      },
        deep:true
      
    },
    "selection_rules.rule_property_id": function(val, oldval) {
      this.resetOptions();
      if (this.who_selection && this.who_selection.conditional_id && this.selection_rules.rule_property_id && this.selection_rules.rule_property_id.conditionals) {
        this.selection_rules.conditional_id = this.selection_rules.rule_property_id.conditionals.filter(
          elem => elem.id == this.who_selection.conditional_id
        )[0];
      }
    },
    "selection_rules.value": function(val) {
      if (this.reset_option_available) {
        //this.selection_rules.value_child = ''
      }
    },
    "selection_rules.conditional_id": function(val, oldval) {
      if (
        typeof this.who_selection.rule_property_id == "object" &&
        oldval != ""
      ) {
        this.selection_rules.value = "";
        this.selection_rules.value_child = "";
      }
      this.updateValue();
    },
    get_selection_rules_ids: function(val) {
      this.$emit("updateConditionWho", val, this.index);
    },
    update_flag: function(val) {
      //reset option available make false
      this.$emit("dataUpdated", false);
      this.$nextTick(() => {
        this.updateData();
      });
    },
    who_selection(val) {
      if (val != this.selection_rules) {
        this.$emit("dataUpdated", false);
        // this.selection_rules = val
        this.updateData();
        setTimeout(() => {
          this.$emit("dataUpdated", true);
        }, 2000);
      }
    },
    automation_options(val) {
      this.updateData();
    }
  },
  created() {
		document.querySelector(".main-section").style['overflow-y'] = "auto";
    this.$store
      .dispatch("getEachFilter", {
        parent_index: this.parent_index,
        index: this.index
      })
      .then(res => {
        if (res) {
          this.automation_options.forEach(elem => {
            if (elem.id == res) {
              this.selection_rules.rule_property_id = elem;
            }
          });
        }
      });
  },
  methods: {
    matchClickedCondition(condition) {
      switch (condition) {
        case "any":
          this.match_all = false;
          //this.connection_text = 'OR'
          break;
        case "all":
          this.match_all = true;
          //this.connection_text = 'AND'
          break;
      }
    },
    dateClear() {
      this.selection_rules.value = "";
    },
    resetOptions() {
      if (this.reset_option_available) {
        this.selection_rules.conditional_id = "";
        this.selection_rules.value = "";
        this.selection_rules.value_child = "";
      }
    },
    clearChildOption() {
      // if(this.who_selection.value_child != ''){
      // 	console.log("here deleted")
      // 	this.selection_rules.value_child = ''
      // }
    },
    updateValueChild() {
      if (
        this.who_selection &&
        this.who_selection.value_child &&
        this.selection_rules.rule_property_id &&
        this.selection_rules.value.children
      ) {
        this.selection_rules.value.children.forEach(elem => {
          if (elem.id == this.who_selection.value_child) {
            this.selection_rules.value_child = elem;
            return;
          }
        });
      }
    },
    updateValue() {
      if (
        this.who_selection &&
        this.who_selection.value &&
        (this.selection_rules.rule_property_id.id == 5 ||
          this.selection_rules.rule_property_id.id == 4) &&
        this.selection_rules.conditional_id &&
        this.selection_rules.conditional_id.id
      ) {
        this.selection_rules.value = this.who_selection.value;
        this.updateValueChild();
      } else {
        if (this.who_selection && this.who_selection.value && this.selection_rules.rule_property_id.data) {
          this.selection_rules.rule_property_id.data.forEach(elem => {
            if (elem.id == this.who_selection.value) {
              this.selection_rules.value = elem;
              if (this.who_selection.value_child) {
                this.updateValueChild();
              }
              return;
            }
          });
        }
      }
    },
    updateData() {
      if (this.who_selection && this.who_selection.rule_property_id && (typeof this.who_selection.rule_property_id != "object") ) {
        // if(typeof this.who_selection.rule_property_id != 'object'){
        //first get the rule_property_id
        this.automation_options.forEach(elem => {
          if (elem.id == this.who_selection.rule_property_id) {
            this.selection_rules.rule_property_id = elem;
          }
        });
      } else {
        this.cleanMemory()
      //  this.selection_rules = this.who_selection;
      }
      //let program know that data is updated
      //need to find a better solution like promise or smt.
      setTimeout(() => {
        this.$emit("dataUpdated", true);
      }, 3000);
    },
    cleanMemory() {
      this.selection_rules = {
        rule_property_id: "",
        conditional_id: "",
        value: "",
        value_child: ""
      };
    }
  }
};
</script>
<style src="../automation.css"



// WEBPACK FOOTER //
// src/components/automation/automationGroups/WHO/whoConditionOptions.vue